import { useTranslation } from "react-i18next";
import { FaCalendarAlt } from "react-icons/fa";
import { Badge } from "primereact/badge";

/**
 * The appointments indicator shown in the collapsed rail.
 *
 * Reuses the Participants → Appointments tab icon (FaCalendarAlt) and the
 * platform's PrimeReact overlay Badge (same pattern as the Messages tab's
 * unread badge). The count is hidden while loading or on error so a failed
 * load never reads as "0 appointments".
 */

export interface CollapsedAppointmentsIndicatorProps {
	count: number;
	showCount: boolean;
}

const CollapsedAppointmentsIndicator = ({
	count,
	showCount,
}: CollapsedAppointmentsIndicatorProps) => {
	const { t } = useTranslation("common");

	const label = showCount
		? t("HOME.RAIL.APPOINTMENTS.COLLAPSED_COUNT", { count })
		: t("HOME.RAIL.APPOINTMENTS.TITLE");

	return (
		<span
			className="p-overlay-badge home-rail__indicator"
			role="img"
			aria-label={label}
			data-testid="home-rail-appointments-indicator"
		>
			<FaCalendarAlt aria-hidden="true" />
			{showCount && count > 0 && (
				<Badge
					value={count}
					className="home-rail__badge"
					data-testid="home-rail-appointments-badge"
				/>
			)}
		</span>
	);
};

export default CollapsedAppointmentsIndicator;
